import { useAppRouter } from '@/common/route/useAppRouter';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';
import { bonusService } from '@/services/bonus';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useBonusLoginAdd() {
    const router = useAppRouter();

    const model = reactive({
        name: '',
        type: null,
        value: '',
        adsBoost: '',
        adsRescue: 0,
        timeUnit: 0,
        timeDuration: 0,
        startTime: new Date()
    });

    const validations = {
        type: { required },
        timeDuration: { required, min: minValue(1), max: maxValue(32000) },
        value: { required, format: validateFormat(/^\d+(,\d+)*$/) },
        adsBoost: { required, format: validateFormat(/^\d+:\d+(,\d+:\d+)*$/) }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().executeAction({
        validator: v$,
        request: () =>
            bonusService.login.create(
                model.name,
                model.type,
                model.value,
                model.adsBoost,
                model.adsRescue,
                model.timeUnit,
                model.timeDuration,
                model?.startTime?.getTime() ?? null
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_BONUS.LOGIN.INDEX })
    });

    return { model, v$, create };
}
